// Filename: bumble_unit.js
// Timestamp: 2017.11.19-13:43:48 (last modified)
// Author(s): bumblehead <chris@bumblehead.com>

const unit_key_weight = () => 50

const unit_pixel_weightarea = ([ w, h ]) => (
  180 / Math.max(w, h))

const unit_pixel_weightelem = (elem = window) => (
  unit_pixel_weightarea(
    elem === window
      ? [ elem.innerWidth, elem.innerHeight ]
      : [ elem.clientWidth, elem.clientHeight ]))

const unit_pixels_as_degrees = (p, pw) => (
  p * (pw || unit_pixel_weightelem()))

const unit_degrees_as_pixels = (d, pw) => (
  d / (pw || unit_pixel_weightelem()))

const unit_degrees_as_radians = d => (
  d * (Math.PI / 180))

const unit_radians_as_degrees = r => (
  r * (180 / Math.PI))

const unit_radians_as_pixels = (r, pw) => (
  unit_degrees_as_pixels(unit_radians_as_degrees(r), pw))

const unit_pixels_as_radians = (p, pw) => (
  unit_degrees_as_radians(unit_pixels_as_degrees(p, pw)))

export {
  unit_key_weight,
  unit_pixel_weightarea,
  unit_pixel_weightelem,
  unit_pixels_as_degrees,
  unit_degrees_as_pixels,
  unit_degrees_as_radians,
  unit_radians_as_degrees,
  unit_radians_as_pixels,
  unit_pixels_as_radians
}
